import { createColumnHelper } from '@tanstack/react-table';
import { OnboardingAuditField } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { AuditName } from '../components/AuditName';
import { TaskStatusTag } from '../components/AuditStatusTag';

const columnHelper = createColumnHelper<OnboardingAuditField>();

export const columns = [
    columnHelper.accessor('fieldIdentifier', {
        header: () => lt('GoLiveAuditsTableColumnIntegration'),
        cell: ({ getValue }) => <AuditName fieldIdentifier={getValue()} />,
    }),
    columnHelper.accessor('status', {
        header: () => lt('GoLiveAuditsTableColumnStatus'),
        cell: ({ getValue }) => <TaskStatusTag status={getValue()} />,
    }),
];
